import React, { useState, useEffect } from "react";
import "./createuser.scss";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { notify } from '../../services/notification';
import { HiMenu, HiX } from "react-icons/hi";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { RoleNameAction } from "../../actions/RoleAction";
import { CreateUserAction } from "../../actions/UserAction";
import { PHONE_NUMBER_REGEX } from "../../constants/regex/regex";
import useMobileView from "../../constants/useMobileView";
import { is2w } from "../../common/isLogin";


function CreateUser() {
    const [loading, setloading] = useState(false);
    const [supervisers, setSupervisers] = useState([]);

    const [roleNames, setRoleNames] = useState([]);
    const { isSidebarOpen, toggleSidebar } = useMobileView();



    const [states, setStates] = useState({
        name: "",
        email: "",
        role_id: "",
        aps_code: "",
    })

    const handleInput = (e) => {
        let key = e.target.name;
        let value = e.target.value;
        if (key === "reports_to_id" || key === "role_id") {
            setStates({ ...states, [key]: Number(value) })
        }
        else if (key === "mobile_number") {
            validatePhoneNumber(value);
        }
        else if (key === "address") {
            setStates({ ...states, [key]: value });
        }
        else if (key === "aps_code") {
            setStates({ ...states, [key]: value });
        }
        else {
            setStates({ ...states, [key]: value.replace(/^ +/gm, ""), })
        }
    }


    const validatePhoneNumber = (value) => {
        const numericValue = value.replace(/\D/g, "");
        if (numericValue === "" || PHONE_NUMBER_REGEX.test(value)) {
            setStates((prevState) => ({
                ...prevState,
                mobile_number: numericValue,
            }));
        }
    };
    const handleOnSaveClick = async (e) => {
        e.preventDefault();
        setloading(true);

        if (states.address !== undefined) {
            states.address = states.address.trim();
            if (states.address === "") {
                delete states.address;
            }
        }
        if (states.aps_code !== undefined) {
            states.aps_code = states.aps_code.trim();
            if (states.aps_code === "") {
                delete states.aps_code;
            }
        }
        
        // Remove aps_code if feature disabled
        if (!is2w()) {
            delete states.aps_code;;
        }

        if (states.mobile_number !== undefined) {
            states.mobile_number = states.mobile_number.trim();
            if (states.mobile_number === "") {
                delete states.mobile_number;
            }
        }
        try {
            let response = await dispatch(CreateUserAction(states));
            if (response?.status === 200) {
                notify.success(response?.data?.message)
                navigate("/user")
            }
        } catch (err) {
            notify.error('Something went wrong. Please try again.');
        } finally {
            setloading(false);
        }
    }





    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        GetRoleNameData()
    }, []);

    async function GetRoleNameData() {
        setloading(true);
        var response = await dispatch(RoleNameAction());
        if (response?.status === 200) {
            setRoleNames(response?.data?.results?.data)
            setSupervisers(response?.data?.results?.data);
            setloading(false);
        } else if (response === undefined) {
            setloading(false);
        }
    }

    return (
        <div className="create-user-container">
            <div className="create-user-containerright">
                <Header title="Create User" />
                <div className="create-user">
                    {loading ? (
                        <Loader />
                    ) : (
                        <form onSubmit={handleOnSaveClick} className="form-div">
                            <div className="grid date">
                                <label className="label-create-user">Full Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Enter Full Name"
                                    value={states.name}
                                    onChange={handleInput}
                                    className="create-role-input-field"
                                    required
                                />
                            </div>
                            {is2w() && (
                                <div className="grid date">
                                    <label className="label-create-user-address">APS Code</label>
                                    <input
                                        type="text"
                                        name="aps_code"
                                        placeholder="Enter APS Code"
                                        value={states.aps_code}
                                        onChange={handleInput}
                                        className="create-role-input-field"
                                    />
                                </div>
                            )}
                            <div className="grid">
                                <label className="label-create-user">Login Id</label>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Enter Login Id"
                                    value={states.email}
                                    onChange={handleInput}
                                    required
                                    className="create-role-input-field"
                                />
                            </div>
                            <div className="grid">
                                <label className="label-create-user-phone-number">Phone Number</label>
                                <input
                                    type="text"
                                    name="mobile_number"
                                    placeholder="Enter Phone Number "
                                    value={states.mobile_number}
                                    minLength={10}
                                    maxLength={10}
                                    onChange={handleInput}
                                    className="create-role-input-field"
                                />
                            </div>
                            <div className="grid">
                                <label className="label-create-user-address">Address</label>
                                <input
                                    type="text"
                                    name="address"
                                    value={states.address}
                                    onChange={handleInput}
                                    placeholder="Enter Address"
                                    className="create-role-input-field"
                                />
                            </div>

                            <div className="grid">
                                <span className="label-create-user"> Role</span>
                                <select className="text-filed-dropdown-user-management" required name="role_id" value={states.role_id} onChange={handleInput}>
                                    <option value="">Select Role</option>
                                    {roleNames?.length > 0 && roleNames?.map((data) => (
                                        <option key={data.id} value={data?.id}>
                                            {data?.role}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {/* // as per discussion with anjali below feature will go to next sprint */}
                            {/* <div className="grid">
                                <label className="label-create-user">Reports to</label>
                            </div>
                            <div className="create-role">
                                <div className="create-role-checkbox-container">
                                    {
                                        supervisers.length > 0 && supervisers.map((val) =>
                                            <div className="create-role-checkbox">
                                                <input className="creates-role-checkbox" type="radio" checked={states?.reports_to_id === val.id ? true : false} name="reports_to_id" value={val.id} onChange={handleInput} />
                                                <label className="creates-roles-label">{val?.role}</label>
                                            </div>
                                        )
                                    }
                                </div>
                            </div> */}
                            <div className="btn-notify">
                                <button
                                    onClick={() => {
                                        navigate("/user");
                                    }}
                                    className="user-active"
                                >
                                    Close
                                </button>
                                <button
                                    className="user-active"
                                    type="submit"
                                    disabled={!states.name || !states.email || !states.role_id
                                        // || !states.reports_to_id
                                    }
                                >
                                    Save
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
export default CreateUser;